import { useNavigate } from "react-router-dom";
import { FaEnvelope } from "react-icons/fa";
import { PublicNav, PublicFooter } from "../components/PublicLayout";
import "./LandingPage.css";

const ContactPage = () => {
  const navigate = useNavigate();

  return (
    <div className="lp-root">
      <PublicNav />

      {/* Hero */}
      <section className="lp-hero" style={{ padding: "80px 20px 100px" }}>
        <div className="lp-hero-inner">
          <div className="lp-hero-badge">Contact</div>
          <h1 className="lp-hero-title" style={{ fontSize: "3rem" }}>
            Questions or <span className="lp-hero-gradient">feedback?</span>
          </h1>
          <p className="lp-hero-sub">
            We'd love to hear from you. Reach out and we'll get back to you as soon as possible.
          </p>
        </div>
      </section>

      {/* Contact card */}
      <section style={{ padding: "80px 20px", background: "#f8fafc", flex: 1 }}>
        <div style={{ maxWidth: 480, margin: "0 auto", background: "white", borderRadius: 20, border: "1px solid #e2e8f0", padding: "48px 40px", textAlign: "center", boxShadow: "0 4px 24px rgba(0,0,0,0.06)" }}>
          <div style={{ width: 64, height: 64, borderRadius: 16, background: "linear-gradient(135deg, #ede9fe, #ddd6fe)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 24px", fontSize: "1.5rem", color: "#6366f1" }}>
            <FaEnvelope />
          </div>
          <h2 style={{ fontSize: "1.4rem", fontWeight: 700, color: "#0f172a", margin: "0 0 12px 0", letterSpacing: "-0.02em" }}>Send us an email</h2>
          <p style={{ color: "#64748b", fontSize: "0.95rem", lineHeight: 1.65, margin: "0 0 28px 0" }}>
            For support, billing questions, or general feedback — we typically respond within one business day.
          </p>
          <a
            href="mailto:Matthew@adsoar.cc"
            style={{ display: "inline-block", padding: "14px 32px", background: "#6366f1", color: "white", borderRadius: 12, fontWeight: 700, fontSize: "1rem", textDecoration: "none", fontFamily: "'Plus Jakarta Sans', sans-serif", transition: "background 0.15s" }}
          >
            Matthew@adsoar.cc
          </a>
          <div style={{ marginTop: 32, paddingTop: 28, borderTop: "1px solid #f1f5f9" }}>
            <p style={{ color: "#94a3b8", fontSize: "0.85rem", margin: 0 }}>Already have an account?{" "}
              <button onClick={() => navigate("/login")} style={{ background: "none", border: "none", color: "#6366f1", fontWeight: 600, cursor: "pointer", fontSize: "0.85rem", fontFamily: "inherit" }}>
                Log in →
              </button>
            </p>
          </div>
        </div>
      </section>

      <PublicFooter />
    </div>
  );
};

export default ContactPage;
